export default __webpack_public_path__ + "static/media/yen.a38e45b6.svg";